import type { PollScoreBar } from '@/containers/DevToolsNew/CommunicationBoard/PollResults/types'
import PollScoreBarRow from './PollScoreBarRow/PollScoreBarRow'
import { BarList } from './styled-components'

interface PollScoreBarsProps {
  bars: PollScoreBar[]
}

const PollScoreBars = ({ bars }: PollScoreBarsProps) => (
  <BarList>
    {bars.map(bar => (
      <PollScoreBarRow key={bar.score} bar={bar} />
    ))}
  </BarList>
)

export default PollScoreBars
